import { registerTimelines } from '@/cinematics';
import { PROLOGUE_TIMELINES } from './data';

export { PROLOGUE_TIMELINES, findPrologueTimeline, sectionTimelineId } from './data';

let registered = false;
export function registerPrologueTimelines(): void {
  if (registered) return;
  registered = true;
  registerTimelines(PROLOGUE_TIMELINES);
}
